import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed, onMounted } from 'vue';
import { useRiveLoader } from '@/composables/useRiveLoader';
import { useInstance } from '@/composables/useInstance';


export default /*#__PURE__*/_defineComponent({
  __name: 'LIframe',
  props: {
    src: null,
    allow: null,
    offsetPadding: { default: 0 },
    id: null,
    crossorigin: null,
    frameborder: null
  },
  emits: ["load"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'load', event: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { src: string, allow?: string, offsetPadding: number, id?: string, crossorigin?: string, frameborder?: string | number };





const { $vuetify } = useInstance();
const isLoading = ref(true);
const size = computed(() => $vuetify.breakpoint.smAndDown ? 120 : 164);
const iframeRef = ref<HTMLIFrameElement | null>(null);
const iframeSrc = ref<string | null>(null);
const isMounted = ref(false);

onMounted(() => {
  isMounted.value = true;
  iframeSrc.value = props.src;
});

const { riveCanvas, canvasWidth, canvasHeight } = useRiveLoader({
  width: size,
  height: size,
});

const iframeHeight = computed(() => {
  const baseHeight = 'calc(100vh - 56px)';
  if (props.offsetPadding > 0) {
    return `calc(100vh - 56px - ${props.offsetPadding}px)`;
  }
  return baseHeight;
});

const handleLoad = (event: Event) => {
  isLoading.value = false;
  emit('load', event);
};

const handleError = () => {
  isLoading.value = false;
};

watch(() => props.src, (newSrc) => {
  if (isMounted.value) {
    iframeSrc.value = newSrc;
  }
  isLoading.value = true;
});

expose({
  iframeRef,
  getIframeElement: () => iframeRef.value,
  getContentWindow: () => iframeRef.value?.contentWindow,
});

return { __sfc: true,props, emit, $vuetify, isLoading, size, iframeRef, iframeSrc, isMounted, riveCanvas, canvasWidth, canvasHeight, iframeHeight, handleLoad, handleError }
}

})